import { useLocation } from 'react-router-dom'
import { ProgramsIcon } from 'src/assets/icons/customIcons/page-icons/Programs'
import { useTranslatable } from 'src/hooks/locale/utils'
import { ErrorBoundary } from 'src/views/components/Error'
import ErrorElement from 'src/views/components/ErrorElement'
import SubPageLayout from 'src/views/includes/SubPageLayout'

export default function AdministratorStatisticsLayout(): JSX.Element | null {
  return (
    <ErrorBoundary errorElement={<ErrorElement />}>
      <PageContent />
    </ErrorBoundary>
  )
}

function PageContent(): JSX.Element | null {
  const t = useTranslatable()
  const { pathname } = useLocation()

  const subBreadcrumbsItems = [
    {
      page: `${t('statistics:statistics')} - ${t(pathname.includes('choices') ? 'common:choices' : 'common:dashboard')}`,
      path: pathname,
    },
  ]

  return (
    <SubPageLayout
      Icon={ProgramsIcon}
      title={t('statistics:statistics')}
      subBreadcrubms={subBreadcrumbsItems}
      pages={[
        {
          title: t('statistics:statistics'),
          link: 'dashboard',
        },
        {
          title: t('statistics:statistics_choices'),
          link: 'choices',
        },
      ]}
    />
  )
}
